import type { FaireProductEntity } from "../../entity_types/product";

export const p_g34vcda8bm: FaireProductEntity = {
  token: "p_g34vcda8bm",
  type: "product",
  name: "HOTEL FLORI",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/b925c3696cd718e2978f4681bbeb208439fc03e5be5a9a38d0ccb5c966b64ff1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60adea8897ed09c2d382fcb73462f0019ee2cb4d52d2568e3c4a127d0eedaab3.jpeg",
    "https://cdn.faire.com/fastly/7e6f32323ba7dd84fd1bd9504cd8e672b20f87e10f337f50c14cd51d9752513b.jpeg"
  ],
  priceDollars: 19,
  description: "A charming hotel hidden among creeping vines, rich in history and old world elegance. Sweeping views along the terrace with the shady green walls and weathered tile floors. Roam the hidden path that leads to the garden, both exquisite and dream-like. Soft notes of verbena and mint fill the air with the subtle hint of cypress from the neighboring woods.\n\n• watermint\n• bright verbana\n• italian cypress\n• sumac leaves\n• coriander seed\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature Italia box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:09.657Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
